import DownloadCookiesPolicy from './DownloadCookiesPolicy';

export default DownloadCookiesPolicy;
